import React, { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PageHeader from "@core/components/pageHeader";
import Donationamount from "views/pages/donation/Donationamount";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const Donation = () => {
  const [donationList, setDonationList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);
  const [permission, setPermission] = useState({});
  const [searchText, setSearchText] = useState("");

  const { userData } = useSelector((state) => state.auth);
  const location = useLocation();
  const [role, setRole] = useState("");

  useEffect(() => {
    if (userData.data.user.role === "2") {
      const donation = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });

      setPermission(donation[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);

  useEffect(() => {
    const fetchDonationList = () => {
      Loader.isLoading(true);

      const payload = {
        pageNo: pageNumber + 1,
        limit: pageSize,
        orderBy: "DESC",
        type: 3,
        searchText: searchText,
      };

      APICall("post", payload, EndPoints.getDonationList)
        .then((response) => {
          const { results, totalCount } = response.data.data;
          if (response.status === 200 && results) {
            setDonationList(results);
            setTotalRecord(totalCount);
          } else {
            setDonationList([]);
          }
          Loader.isLoading(false);
        })
        .catch((error) => {
          Loader.isLoading(false);
          return error;
        });
    };
    fetchDonationList();
  }, [pageSize, pageNumber, searchText]);

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Donation
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <Donationamount
            donationList={donationList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            permission={permission}
            role={role}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Donation;
